<script setup lang="ts">
const env = useEnv();
const cookie = useCsrfCookie(`${env.domains.api}/v2/sanctum/csrf-cookie`);
</script>

<template>
  <slot v-if="cookie.error.value" name="error">
    <UiErrorApi :error="cookie.error.value" />
  </slot>
  <slot v-else-if="cookie.status.value !== 'success'" name="loading">
    <main class="min-h-screen bg-elevated">
      <WaiverFormSkeleton />
    </main>
  </slot>
  <slot v-else />
</template>
